export default __webpack_public_path__ + "static/media/FD10.e99c6daa.PNG";